import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
	selector: '[appRowColumn]',
	standalone: true
})
export class RowColumn {
	@Input('appRowColumn') key!: string;
	constructor(public template: TemplateRef<any>) {}
}
